export default __webpack_public_path__ + "static/media/flash19.2dc469e3.png";